import { useEffect } from "react";
import { useUsersStore } from "../stores/users.store";

interface UserNameProps {
  userId: string;
  small?: boolean;
  level?: boolean;
}

const UserName: React.FC<UserNameProps> = ({ userId, small, level }) => {
  const user = useUsersStore(state =>
    state.users.find(u => u.userId === userId)
  );
  const subscribeToUser = useUsersStore(state => state.subscribeToUser);

  useEffect(() => {
    if (!user) {
      const unsubscribe = subscribeToUser(userId);
      return () => {
        unsubscribe();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const userName = user?.username.startsWith("@")
    ? user?.username.substring(1, 10)
    : user?.username.substring(0, 10);
  return (
    <div className="text-xs font-normal uppercase flex items-center">
      <span
        className={`inline-block h-2 w-2 rounded-full mr-1 ${
          user?.isOnline ? "bg-green-500" : "bg-red-500"
        }`}
      ></span>
      <span className={`mr-2 ${small && "text-[8px]"}`}>@{userName}</span>
      {level && (
        <span className="inline-block h-2 w-2 rounded-full bg-green-500 mr-1">
          2
        </span>
      )}
    </div>
  );
};

export default UserName;
